import Typography from '@mui/material/Typography';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../../Firebase/firebase.js';
import React, { useState, useEffect } from 'react';
// import emailjs from 'emailjs-com'; //was updated in new version
import emailjs from '@emailjs/browser';
import { Box, Button, TextField } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext/index.jsx';
import SearchBar from '../../Components/SearchBar/index.jsx';

const ContactUs = () => {
  const { currentUser } = useAuth();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [confirmation, setConfirmation] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      from_name: formData.name, // Name of the person sending the email
      to_name: 'Xpat360', // Name of the person receiving the email
      message: formData.message, // The content of the message
      reply_to: formData.email, // The reply-to email address
      to_email: 'dkyeboah1@gmail.com', // Ensure this email matches your intended recipient
    };

    //Name:Gmail
    //Service ID: service_7khwg2g
    emailjs
      .send(
        'service_7khwg2g',
        'template_k57u4k4',
        templateParams,
        'W29y5Sf_JXE6KOTi-'
      )
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setConfirmation('Your message has been sent successfully!');
        setFormData({ name: '', email: '', subject: '', message: '' });
      })
      .catch((err) => {
        console.error('FAILED...', err);
        setConfirmation(
          'There was an error sending your message. Please try again later.'
        );
      });
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (currentUser) {
        setFormData((prevData) => ({
          ...prevData,
          email: currentUser.email, // Prefill email
        }));

        const userDocRef = doc(db, 'users', currentUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setFormData((prevData) => ({
            ...prevData,
            name: userData.name || 'Puke', // Prefill name if available
          }));
        }
      }
    };

    fetchUserDetails();
  }, []);

  return (
<Box>
    <Box
    sx={{
      display: { xs: 'flex', sm: 'flex', lg: 'none', xl: 'none' },
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'white',
      pb: 0.5,
      height: 45,
      ml: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
      position: 'sticky',
      top: 0,
      zIndex: 1000, // Ensure it's above other content while scrolling
      mb:0
    }}
  >
    <SearchBar width={300} />
  </Box>
    <Box
      component='form'
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mt: 0,
      }}
    >
               
      <Typography
        variant='h4'
        sx={{
          display: { xs: 'flex', md: 'flex' },
          fontFamily: 'Montserrat',
          
          letterSpacing: '.3rem',
          fontSize: { xs: 12, sm: 12, md: 13, lg: 15, xl: 15 },
          flexDirection: 'center',
          textDecoration: 'none',
          mt: 3,
        }}
        gutterBottom
      >
        Contact Us
      </Typography>
      <Typography
        variant='body1'
        sx={{
          mt: 2,
          display: { xs: 'flex', md: 'flex' },
          fontFamily: 'Montserrat',
          width: { xs: '89%', sm: '85%', md: '70%', lg: '50%', xl: '50%' },
          fontWeight: 100,
          letterSpacing: '0rem',
          fontSize: { xs: 9, sm: 9, md: 14, lg: 16, xl: 16 },
          flexDirection: 'center',
          textDecoration: 'none',
          cursor: 'pointer', // Change cursor to pointer to indicate it's clickable
        }}
        gutterBottom
      >
        Got a question, suggestion, or just want to say hello? We’d love to hear
        from you! Fill out the form below, and we’ll get back to you as soon as
        possible.
      </Typography>

      <Box
        sx={{
          mt: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          width: { xs: '90%', sm: '90%', md: '80%', lg: '50%', xl: '50%' },
          overflowY: 'auto',
        }}
      >
        <Box sx={{ mt: 2 }}>
          <TextField
            label='Name'
            name='name'
            value={formData.name}
            onChange={handleChange}
            variant='outlined'
            fullWidth
            sx={{ mb: 2 }} // Adjust width and height
            InputProps={{
              sx: {
                height: '50px', // Set the height of the input box
                fontFamily: 'Montserrat',
                fontSize: {
                  xs: '12px',
                  sm: '12px',
                  md: '12px',
                  lg: '14px',
                  xl: '14px',
                }, // Adjust the label font size
              },
            }}
          />
          <TextField
            label='Email'
            name='email'
            value={formData.email}
            onChange={handleChange}
            variant='outlined'
            fullWidth
            type='email' // Enforce email format validation
            sx={{ mb: 2 }}
            InputProps={{
              sx: {
                height: '50px', // Set the height of the input box
                fontFamily: 'Montserrat',
                fontSize: {
                  xs: '12px',
                  sm: '12px',
                  md: '12px',
                  lg: '14px',
                  xl: '14px',
                }, // Adjust the label font size
              },
            }}
          />
          <TextField
            label='Subject'
            name='subject'
            value={formData.subject}
            onChange={handleChange}
            variant='outlined'
            fullWidth
            sx={{ mb: 2 }}
            InputProps={{
              sx: {
                height: '50px', // Set the height of the input box
                fontFamily: 'Montserrat',
                fontSize: {
                  xs: '12px',
                  sm: '12px',
                  md: '12px',
                  lg: '14px',
                  xl: '14px',
                }, // Adjust the label font size
              },
            }}
          />
          <TextField
            label='Message'
            name='message'
            value={formData.message}
            onChange={handleChange}
            variant='outlined'
            multiline
            rows={5}
            fullWidth
            sx={{ mb: 2 }}
            InputProps={{
              sx: {
                height: {
                  xs: '140px',
                  sm: '140px',
                  md: '150px',
                  lg: '160px',
                  xl: '160px',
                }, // Set the height of the input box
                fontFamily: 'Montserrat',
                fontSize: {
                  xs: '12px',
                  sm: '12px',
                  md: '12px',
                  lg: '14px',
                  xl: '14px',
                }, // Adjust the label font size
              },
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              sx={{
                width: { xs: '35%', md: '35%', lg: '20%', xl: '20%' },
                backgroundColor: 'darkblue',
                borderRadius: '20px',
                fontSize: { xs: 11, sm: 11, md: 13, lg: 14, xl: 14 },
              }}
              type='submit'
              variant='contained'
              color='primary'
            >
              Send Message
            </Button>
          </Box>
          {confirmation && (
            <Typography variant='body1' color='secondary' sx={{ mt: 2 }}>
              {confirmation}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
    </Box>
  );
};

export default ContactUs;
